import { useLocation, useNavigate } from 'react-router-dom'

import {
  getExportAnalysisListPath,
  getRequestsBasePath,
  isAirlockRequestsV3RoutesEnabled
} from 'modules/requests/requestDetailPaths'
import {
  ExportAndAccessSubTabKeys,
  RequestsTabKeys,
  isExportAndAccessSubTabKey
} from 'modules/requests/requestsTabKeys'

export const useExportAndAccessRequestsTab = (): {
  activeSubTabKey: ExportAndAccessSubTabKeys
  onSelectSubTab: (tabKey: string) => void
} => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const exportTabKey = isAirlockRequestsV3RoutesEnabled() ? RequestsTabKeys.Export : RequestsTabKeys.ExportAndAccess

  const activeSubTabKey =
    pathname === getExportAnalysisListPath() ? ExportAndAccessSubTabKeys.Analysis : ExportAndAccessSubTabKeys.Files

  const onSelectSubTab = (tabKey: string) => {
    if (!isExportAndAccessSubTabKey(tabKey)) return

    navigate(`${getRequestsBasePath()}/${exportTabKey}/${tabKey}`)
  }

  return {
    activeSubTabKey,
    onSelectSubTab
  }
}
